import { TemplateConfig } from '../types';

export const unemploymentTurnaroundSpreadConfig: TemplateConfig = {
  id: 'unemployment-turnaround-spread',
  name: '待业转机牌阵',
  description: '分析待业原因与转机方向',
  cardCount: 8,
  
  fieldDefaults: {
    title: '待业转机牌阵',
    customerQuestion: '分析我待业的原因是什么，接下来应该用什么方法来找工作。',
    cardPlaceholders: [
      '请输入第 2 列第 1 张牌',
      '请输入第 1 列第 1 张牌',
      '请输入第 2 列第 2 张牌',
      '请输入第 3 列第 1 张牌',
      '请输入第 2 列第 3 张牌',
      '请输入第 1 列第 2 张牌',
      '请输入第 3 列第 2 张牌',
      '请输入第 3 列第 3 张牌'
    ],
    cardInfos: [
      '【当前状态真相】你现在待业的核心原因是什么？例如：是机会太少？简历不给力？还是你内心其实根本没准备好重返职场？',
      '【内在障碍】️你自己给自己设下的“隐形门槛”是什么？例如：太怕失败、不敢降薪、不愿改变原行业……',
      '【外部现实】当前职场环境/行业的客观因素是怎样的，对你造成了哪些影响？',
      '【重新出发的定位点】现在的你，更适合以什么身份/方向重启？例如：是同岗位求稳？转行尝试？还是做副业过渡？',
      '【隐藏竞争力】你有哪些自己没意识到的“找工作加分项”？例如：可能是性格优势、旧人脉、兼职经历……',
      '【找工作的致命误区】你在哪些方面，一直用错了方法？例如：瞎投简历 / 没有主线 / 不懂展现价值……',
      '【突破机会点】接下来30天，你最有可能突破的“转机点”在哪里？例如：人脉？某个平台？一次面试？一项自我提升？',
      '【3个月内的复职运势】如果你按指引调整，最可能的结果是什么？能不能找到合适工作？大概在哪个方向？'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#1677ff',
    backgroundColor: '#e6f4ff',
    icon: '🧭'
  }
};
